/* ============================================================
   CALCULATEUR NOMBRE DE PALETTES PAR RACK — hero DA (fiche 2 zones)
   palettes/niveau = ⌊ longueur lisse / (façade palette + marge) ⌋
   total = palettes/niveau × niveaux × travées
   ============================================================ */
(function () {
  'use strict';
  const root = document.getElementById('calc-pal-root');
  if (!root) return;
  const $ = (s) => root.querySelector(s);
  const lisse = $('#pal-lisse');
  const facade = $('#pal-facade');
  const niveaux = $('#pal-niveaux');
  const travees = $('#pal-travees');
  const btn = $('#pal-go');
  const results = $('#pal-results');
  const summary = $('#pal-summary');
  const MARGE = 100; // mm de jeu par palette (norme EN 15620 ~75-100mm)

  const fmt = (n) => Math.round(n).toLocaleString('fr-FR');
  const arrow = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12h14M12 5l7 7-7 7"/></svg>';
  const pencil = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.12 2.12 0 0 1 3 3L12 15l-4 1 1-4z"/></svg>';

  function showForm() { root.classList.remove('is-calculated'); results.hidden = true; lisse.focus(); }

  function calculate() {
    const L = parseFloat(lisse.value), F = parseFloat(facade.value);
    const N = parseInt(niveaux.value, 10), T = parseInt(travees.value, 10);
    if (!L || !F || !N || !T || L <= 0 || F <= 0 || N <= 0 || T <= 0) {
      root.classList.remove('is-calculated'); results.hidden = true;
      [lisse, facade, niveaux, travees].forEach((i) => { if (!i.value) i.reportValidity && i.reportValidity(); });
      return;
    }
    const parNiveau = Math.max(0, Math.floor(L / (F + MARGE)));
    const total = parNiveau * N * T;
    const alveoles = N * T;

    const left =
      '<div class="ch-zone ch-zone-left">' +
        '<p class="ch-r-eyebrow ch-reveal">Capacité du rack</p>' +
        '<p class="ch-r-total ch-reveal"><span>' + fmt(total) + '</span><i class="ch-r-unit">palettes</i></p>' +
        '<p class="ch-r-sub ch-reveal">' + fmt(parNiveau) + ' palettes/niveau · ' + N + ' niveaux · ' + T + ' travées</p>' +
        '<div class="ch-lines ch-reveal ch-r2">' +
          '<div class="ch-line"><span class="ch-line-k">Palettes par niveau</span><span class="ch-line-v">' + fmt(parNiveau) + '</span></div>' +
          '<div class="ch-line"><span class="ch-line-k">Alvéoles (niv. × travées)</span><span class="ch-line-v">' + fmt(alveoles) + '</span></div>' +
          '<div class="ch-line ch-line--em"><span class="ch-line-k">Total palettes</span><span class="ch-line-v">' + fmt(total) + '</span></div>' +
        '</div>' +
      '</div>';

    const right =
      '<div class="ch-zone ch-zone-right ch-reveal ch-r3">' +
        '<span class="ch-badge">Rayonnage conseillé</span>' +
        '<h3 class="ch-reco-h">Rack à palettes</h3>' +
        '<p class="ch-reco-d">Configuration adaptée à vos palettes. Le chiffrage exact dépend des lisses, échelles et charges réelles.</p>' +
        '<ul class="ch-stats">' +
          '<li><span>Palettes / niveau</span><b>' + fmt(parNiveau) + '</b></li>' +
          '<li><span>Niveaux</span><b>' + N + '</b></li>' +
          '<li><span>Travées</span><b>' + T + '</b></li>' +
          '<li class="win"><span>Total palettes</span><b>' + fmt(total) + '</b></li>' +
        '</ul>' +
        '<a href="/pages/devis" class="ds-cta-btn ds-cta-btn-primary ch-rcta">Obtenir mon devis gratuit ' + arrow + '</a>' +
        '<a href="/collections/all-rayonnage" class="ch-rlink">Voir les racks à palettes →</a>' +
      '</div>';

    results.innerHTML = '<div class="ch-rbody">' + left + right + '</div>';
    results.hidden = false;
    summary.innerHTML =
      '<span class="ch-sum-tag">Votre rack</span>' +
      '<div class="ch-summary-chips">' +
        '<span class="ch-chip">lisse ' + fmt(L) + ' mm</span>' +
        '<span class="ch-chip">façade ' + fmt(F) + ' mm</span>' +
        '<span class="ch-chip">' + N + ' niveaux</span>' +
        '<span class="ch-chip">' + T + ' travées</span>' +
      '</div>' +
      '<button type="button" class="ch-modify" id="pal-modify">' + pencil + 'Modifier</button>';
    root.classList.add('is-calculated');
    const mod = $('#pal-modify'); if (mod) mod.addEventListener('click', showForm);
  }

  btn.addEventListener('click', calculate);
  [lisse, facade, niveaux, travees].forEach((i) => i.addEventListener('keypress', (e) => { if (e.key === 'Enter') calculate(); }));
})();
